
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './SearchInput.css';
import withStyles from '../../decorators/withStyles';


class SearchInput extends Component {

  static propTypes = {
    value: PropTypes.string.isRequired,
    autofocus: PropTypes.bool.isRequired,
    handleFocus: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleKeyDown: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <form className="search" target="#" onSubmit={this.props.handleSubmit}>
        <input
          className="query type-regular"
          placeholder={this.props.placeholder}
          value={this.props.value}
          type="search"
          onFocus={this.props.handleFocus}
          onKeyDown={this.props.handleKeyDown}
          onChange={this.props.handleChange}
          autoFocus={this.props.autofocus}
        />

        <input className="submit" type="submit" value=""/>
        <span className="icon-wrap"><span className="icon search"></span></span>
        <div className="search-error">
          <a href="#" className="close">×</a>
          <div className="error-text"></div>
        </div>
      </form>
    )
  }
}

export default withStyles(styles)(SearchInput);
